/*
 *
 * Admin/AssessmentResultTestTool constants
 *
 */

export const PROCESSING = 'app/Admin/AssessmentResultTestTool/PROCESSING';
export const GET_ASSESSMENTS_DATA =
  'app/Admin/AssessmentResultTestTool/GET_ASSESSMENTS_DATA';
export const GET_ASSESSMENTS_DATA_RESULT =
  'app/Admin/AssessmentResultTestTool/GET_ASSESSMENTS_DATA_RESULT';
export const SUBMIT_ASSESSMENT_TEST_DATA =
  'app/Admin/AssessmentResultTestTool/SUBMIT_ASSESSMENT_TEST_DATA';
export const GET_STORED_DATA =
  'app/Admin/AssessmentResultTestTool/GET_STORED_DATA';
export const GET_STORED_DATA_RESULT =
  'app/Admin/AssessmentResultTestTool/GET_STORED_DATA_RESULT';
